/* eslint-disable @typescript-eslint/no-unused-vars */

import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import { axiosInstance } from "../axios-instance";

class LocatorCommands {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  factoryReset(input: any): Promise<AxiosResponse<any>> {
    const accessToken = localStorage.getItem('accessToken');
    const authInfo: any = this.authClient?.authenticate();
    const data = {configs: [input], userId: authInfo.loginId, applicationId: 'iot-gateway'};
    return axiosInstance.post<any>(`${this.baseUrl}/factoryReset`, data, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }).catch((error) => {
      throw new Error(error);
    });
  }

  queueCommands(input: any): Promise<AxiosResponse<any>> {
    const accessToken = localStorage.getItem('accessToken');
    const authInfo: any = this.authClient?.authenticate();
    const data = {configs: [input], userId: authInfo.loginId, applicationId: 'iot-gateway'};
    return axiosInstance.post<any>(`${this.baseUrl}/queueCommands`, data, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }).catch((error) => {
      throw new Error(error);
    });
  }
}

export default LocatorCommands;
